export const GET_ADDRESSES = 'ADDRESSES';
export const GET_ADDRESSES_SUCCESS = 'GET_ADDRESSES_SUCCESS';
export const GET_ADDRESSES_ERROR = 'GET_ADDRESSES_ERROR';
export const UPDATE_ADDRESSES = 'UPDATE_ADDRESSES';
export const UPDATE_ADDRESSES_SUCCESS = 'UPDATE_ADDRESSES_SUCCESS';
export const UPDATE_ADDRESSES_ERROR = 'UPDATE_ADDRESSES_ERROR';
export const POST_ADDRESSES = 'POST_ADDRESSES';
export const POST_ADDRESSES_SUCCESS = 'POST_ADDRESSES_SUCCESS';
export const POST_ADDRESSES_ERROR = 'POST_ADDRESSES_ERROR';
export const DELETE_ADDRESSES = 'DELETE_ADDRESSES';
export const DELETE_ADDRESSES_LOADING = 'DELETE_ADDRESSES_LOADING';
export const DELETE_ADDRESSES_CREATE = 'DELETE_ADDRESSES_CREATE';
export const DELETE_ADDRESSES_UPDATE = 'DELETE_ADDRESSES_UPDATE';
export const DELETE_ADDRESSES_SUCCESS = 'DELETE_ADDRESSES_SUCCESS';
export const DELETE_ADDRESSES_CREATE_SUCCESS = 'DELETE_ADDRESSES_CREATE_SUCCESS';
export const DELETE_ADDRESSES_ERROR = 'DELETE_ADDRESSES_ERROR';
export const CLEAN_REQUEST_ADDRESSES = 'CLEAN_REQUEST_ADDRESSES';
export const HIDE_ADDRESS = 'HIDE_ADDRESS';
export const SET_DEFAULT_ADDRESS = 'SET_DEFAULT_ADDRESS';
